module.exports = {
  footerText: 'Copyright REALTISM © 2020',
};
